'use client';

import { usePathname } from 'next/navigation';
import { useEffect, useRef } from 'react';
import { trackPageView } from '../track-page-view';

export function useAnalyticsPageView(): void {
  const pathname = usePathname();
  const isInitialRef = useRef(true);

  useEffect(() => {
    if (isInitialRef.current) {
      isInitialRef.current = false;
      return;
    }
    if (pathname) {
      trackPageView(pathname);
    }
  }, [pathname]);
}
